import { ModelInstance, BaseModel, ToFrontHook, ToBackHook, listField } from './util';
import { File } from './file';

@ModelInstance({
  mappingFields: {
    id: 'id',
    name: 'name',
    files: 'files',
    key_code: 'keyCode',
  },
  relation: {
    files: listField(File)
  }
})
export class LeaguePlaylist extends BaseModel {
  id: number;
  name: string;
  files: File[];
  keyCode: string;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
